const API_BASE_URL = "/api";

const request = async (url, options = {}) => {
  const response = await fetch(`${API_BASE_URL}${url}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.message || "خطایی رخ داده است.");
  }

  return data;
};

export const registerUser = async (userData) =>
  request("/auth/register", {
    method: "POST",
    body: JSON.stringify(userData),
  });

export const loginUser = async (loginData) =>
  request("/auth/login", {
    method: "POST",
    body: JSON.stringify(loginData),
  });

export const forgotPasswordUser = async (email) =>
  request("/auth/forgot-password", {
    method: "POST",
    body: JSON.stringify({ email }),
  });

export const resetPasswordUser = async (token, passwordData) =>
  request(`/auth/reset-password/${token}`, {
    method: "POST",
    body: JSON.stringify(passwordData),
  });

export const getProfile = async () => {
  const token = localStorage.getItem("authToken");

  return request("/auth/me", {
    method: "GET",
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
};
